// extracted by mini-css-extract-plugin
module.exports = {"container":"ReciterStationList_container__zUdts"};